import axios from "axios";
import SHA256 from 'crypto-js/sha256';

export default {
    data() {
        return {
            practiceCode: this.$store.state.practiceCode,
        }
    },
    methods: {
        setUpInfo() {
            this.getGoogleTagManager()
            this.setLogToken()
            this.getPostalCodeCheckValue()
            this.getHeaderInfo()
            this.getIntakeSettings()
            this.getShowEstablishmentAddress()
            this.getRedirectUrl()
            this.getLocations()
            this.getGoogleTagManagerId()
            this.getShowDescriptionPrice()
            this.getStyle()
            this.getMutationSettings()
            this.getWeeksAhead()
            this.getMinHoursAhead()
            this.getShowPatientRemark()
        },
        getPostalCodeCheckValue() {
            axios.get(process.env.VUE_APP_API_URL + 'postalCodeCheckValue/?practice=' + this.practiceCode, {
                params: {logToken: this.$store.getters.getLogToken}
            }).then((response) => {
                let results = response.data;
                this.postalCodeCheck = results.value
                this.$store.commit('setPatientPostalCode', null)
                this.$store.commit('setPostalCodeCheck', this.postalCodeCheck)
            })
        },
        getShowDescriptionPrice() {
            axios.get(process.env.VUE_APP_API_URL + 'showDescriptionPrice/?practice=' + this.practiceCode, {
                params: {logToken: this.logToken}
            }).then((response) => {
                let results = response.data;
                this.showDescriptionPrice = results.value
                this.$store.commit('setShowDescriptionPrice', this.showDescriptionPrice)
            })
        },
        getShowEstablishmentAddress() {
            axios.get(process.env.VUE_APP_API_URL + 'showEstablishmentAddress/?practice=' + this.practiceCode, {
                params: {logToken: this.logToken}
            }).then((response) => {
                let results = response.data;
                this.showEstablishmentAddress = results.value
                this.$store.commit('setShowEstablishmentAddress', this.showEstablishmentAddress)
            })
        },
        getHeaderInfo() {
            axios.get(process.env.VUE_APP_API_URL + 'headerInfo/?practice=' + this.practiceCode, {
                params: {logToken: this.logToken}
            }).then((response) => {
                let result = response.data;
                this.$store.commit('setHeaderInfo', result)
                if (
                    result.showLogo
                    && result.logoExists
                ) {
                    this.getLogoLink()
                }
            })
        },
        getLogoLink() {
            this.$store.commit('setLogo', process.env.VUE_APP_API_URL + 'logo/?practice=' + this.$store.state.practiceCode)
        },
        getRedirectUrl() {
            axios.get(process.env.VUE_APP_API_URL + 'redirectUrl/?practice=' + this.practiceCode, {
                params: {logToken: this.logToken}
            }).then((response) => {
                let result = response.data.redirectUrl;
                if (result !== false) {
                    this.$store.commit('setRedirectUrl', result)
                }
            })
        },
        getIntakeSettings() {
            axios.get(process.env.VUE_APP_API_URL + 'getIntakeSettings/?practice=' + this.practiceCode, {
                params: {logToken: this.logToken}
            }).then((response) => {
                this.$store.commit('setIntakeEnabled', response.data.intakeEnabled)
                this.$store.commit('setIntakeText', response.data.intakeText)
            })
        },
        getMutationSettings() {
            axios.get(process.env.VUE_APP_API_URL + 'getMutationSettings/?practice=' + this.practiceCode, {
                params: {logToken: this.logToken}
            }).then((response) => {
                this.$store.commit('setMutationSettings', response.data.mutationSettings)
            })
        },
        getLocations() {
            axios.get(process.env.VUE_APP_API_URL + 'location/?practice=' + this.practiceCode, {
                params: {logToken: this.logToken}
            }).then((response) => {
                let result = response.data;
                if (result !== false) {
                    this.$store.commit('setLocations', result)
                }
            })
        },
        getGoogleTagManagerId() {
            axios.get(process.env.VUE_APP_API_URL + 'gtmId/?practice=' + this.practiceCode, {
                params: {logToken: this.logToken}
            }).then((response) => {
                let result = response.data;
                if (result.gtmId !== false && typeof result.gtmId !== 'undefined') {
                    this.$store.commit('setGtmId', result)
                }
            })
        },
        getGoogleTagManager() {
            axios.get(process.env.VUE_APP_API_URL + 'getGtm/?practice=' + this.practiceCode, {
                params: {logToken: this.logToken}
            }).then((response) => {
                let gtmData = response.data;

                const expectedChecksumHead = gtmData.gtmScriptHeadChecksum;
                const expectedChecksumBody = gtmData.gtmScriptBodyChecksum;

                const startComment = document.createComment('Google Tag Manager');
                const endComment = document.createComment('End Google Tag Manager');

                if (gtmData.gtmScriptHead && typeof gtmData.gtmScriptHead !== 'undefined') {
                    const calculatedChecksumHead = SHA256(gtmData.gtmScriptHead).toString();

                    if (calculatedChecksumHead === expectedChecksumHead) {
                        if (!document.getElementById('gtm-script')) {
                            const rawScriptHead = gtmData.gtmScriptHead.trim()
                                .replace(/^["']|["']$/g, '')
                                .replace(/<script[^>]*>/i, '')
                                .replace(/<\/script>/i, '');

                            const script = document.createElement('script');
                            script.id = 'gtm-script';
                            script.innerHTML = rawScriptHead;

                            const head = document.head;

                            head.appendChild(startComment);
                            head.appendChild(script);
                            head.appendChild(endComment);
                        }
                    } else {
                        console.error("Checksum mismatch for GTM head script!");
                    }
                }

                if (gtmData.gtmScriptBody && typeof gtmData.gtmScriptBody !== 'undefined') {
                    const calculatedChecksumBody = SHA256(gtmData.gtmScriptBody).toString();

                    if (calculatedChecksumBody === expectedChecksumBody) {
                        if (!document.getElementById('gtm-noscript')) {
                            const rawScriptBody = gtmData.gtmScriptBody.trim()
                                .replace(/^["']|["']$/g, '')
                                .replace(/<!--[\s\S]*?-->/g, '');

                            const tempDiv = document.createElement('div');
                            tempDiv.innerHTML = rawScriptBody;

                            let noscriptEl = tempDiv.querySelector('noscript');

                            if (!noscriptEl) {
                                noscriptEl = document.createElement('noscript');
                                noscriptEl.innerHTML = rawScriptBody;
                            }

                            noscriptEl.id = 'gtm-noscript';
                            const body = document.body;

                            body.insertBefore(startComment, body.firstChild);
                            body.insertBefore(noscriptEl, body.firstChild);
                            body.appendChild(endComment);
                        }
                    } else {
                        console.error("Checksum mismatch for GTM body script!");
                    }
                }
            }).catch((error) => {
                console.error("Error loading GTM:", error);
            });
        },
        getStyle() {
            axios.get(process.env.VUE_APP_API_URL + 'getColors/?practice=' + this.practiceCode, {
                params: {logToken: this.logToken}
            }).then((response) => {
                let result = response.data;
                this.$store.commit('setColors', result.colors)
            })
        },
        getWeeksAhead() {
            axios.get(process.env.VUE_APP_API_URL + 'weeksAhead/?practice=' + this.practiceCode).then((response) => {
                let result = response.data;
                this.$store.commit('setWeeksAhead', result.value)
            })
        },
        getMinHoursAhead() {
            axios.get(process.env.VUE_APP_API_URL + 'getMinHoursAhead/?practice=' + this.practiceCode).then((response) => {
                let result = response.data;
                this.$store.commit('setMinHoursAhead', result.value)
            })
        },
        getShowPatientRemark() {
            axios.get(process.env.VUE_APP_API_URL + 'showPatientRemark/?practice=' + this.practiceCode).then((response) => {
                let result = response.data;
                this.$store.commit('setPatientRemarkEnabled', result.value)
            })
        }
    },
    computed: {
        logToken() {
            return this.$store.getters.getLogToken
        }
    }
}